import { render, staticRenderFns } from "./prototype.vue?vue&type=template&id=5e7a0968&"
import script from "./prototype.vue?vue&type=script&lang=js&"
export * from "./prototype.vue?vue&type=script&lang=js&"
import style0 from "./prototype.vue?vue&type=style&index=0&id=5e7a0968&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports